import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import * as React from 'react';
import { useState } from 'react';
import { IEventV2 } from '../../../data/entities/event';
import { Paragraph } from '../paragraph/Paragraph';

interface IProcessPaymentModalProps {
	event: IEventV2;
	onRequestClose: () => any;
	process: (propertyId: string | number, eventId: string) => any;
}

export const ProcessPaymentModal: React.FC<IProcessPaymentModalProps> = (props) => {
	const { event, process, onRequestClose } = props;
	const [processing, setProcessing] = useState(false);

	const loadingPhrases = [
		'Hold on, we\'re counting the pennies',
		'Hold on, we\'re carrying the one',
		'Hold on, we\'re asking the bank',
		'Please wait, we\'re doing maths',
		'Please wait, maths is hard',
		'Please wait, we\'re calculating numbers',
	];

	const randomLoadingPhrase = loadingPhrases[Math.floor(Math.random() * loadingPhrases.length)];

	const onProcess = async () => {
		setProcessing(true);
		await process(event.property_id, event.id);
		// we're having issues with CX blazing through processing bookings and saving old data on
		// top of new data in the background so we're having a nap here.
		await new Promise((r) => setTimeout(r, 10000));
		// enforcing a hard refresh here, so we hopefully get rid of stale data.
		window.location.reload();
		// onRequestClose();
	};

	return <Modal
		title={`Process payment`}
		shouldCloseOnOverlayClick={false}
		onRequestClose={onRequestClose}
		actionRHS={
			<Button
				id={`process_payment`}
				onClick={onProcess}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
				loading={processing}
			>
				{`Process payment`}
			</Button>}
	>
		<div className="payment-processing__content">
			<Paragraph>
				Are you sure you want to process a <span className="booking-payment-internal__text-highlight">payment</span> for this booking?
			</Paragraph>
			{processing ? <Paragraph><span className="booking-payment-internal__text-highlight">{randomLoadingPhrase}...</span></Paragraph> : null}
		</div>
	</Modal>;
};
